/**
 * Kachel „Art“ im Vorgangskopf (Mockup vorgangskopf-handy, Antoine 16.10.2026: „Mit Art“): die Art
 * des Essens, abgeleitet aus Daten, die schon da sind — den Positionen der maßgeblichen Variante
 * (`GET /api/offers/:id/full`) und der Paketart (`packages.kind`: menu | buffet | flat, aus
 * `GET /api/packages`). Kein eigenes Feld, kein neuer Endpunkt. `null` = nichts Belastbares,
 * die Kachel bleibt weg.
 */
import type { OfferItem } from "../ui/types";

export interface PaketArt {
  id: string;
  kind: string;
  name: string;
}

export function essensArt(
  items: Pick<OfferItem, "section" | "courseLabel" | "packageId">[] | null | undefined,
  pakete: PaketArt[] | null | undefined,
  titel?: string | null,
): string | null {
  const menue = (items ?? []).filter((i) => i.section === "menu");
  if (menue.length === 0) return null;
  const paketIds = new Set(menue.map((i) => i.packageId).filter(Boolean));
  const genutzt = (pakete ?? []).filter((p) => paketIds.has(p.id));
  // ponytail: Fingerfood ist keine Paketart, nur am Namen erkennbar; ein eigenes Feld, wenn es öfter danebenliegt.
  const namen = [titel ?? "", ...genutzt.map((p) => p.name)].join(" ");
  if (/fingerfood|flying/i.test(namen)) return "Fingerfood";
  if (genutzt.some((p) => p.kind === "buffet") || /buffet/i.test(namen)) return "Buffet";
  const gaenge = new Set(menue.map((i) => i.courseLabel?.trim().toLowerCase()).filter(Boolean)).size;
  if (gaenge > 0) return `Menü · ${gaenge} ${gaenge === 1 ? "Gang" : "Gänge"}`;
  if (genutzt.some((p) => p.kind === "menu")) return "Menü";
  return null;
}
